import BASE_API from '@/api/dataBase';

export const formCells = (ctx) => {
  return [
    {
      prop: 'contractCode',
      name: '合同编号',
      placeholder: '自动生成',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'paperContractNumber',
      name: '纸质合同编号',
      placeholder: '请输入',
      type: 'input',
    },
    { prop: 'contractName', name: '合同名称', placeholder: '请输入合同名称', type: 'input' },
    {
      prop: 'createDepartmentName',
      name: '创建组织',
      type: 'input',
      // type: 'treeSelect',
      // apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
      // isName: true, // 是否返回名字
      // returnType: 'object', // 全部返回当前对象
      // multiple: false,
      // currentValue: ctx.baseInfoData.createDepartmentNo, // 默认选中的
      // apiData: {
      //   tenantCode: ctx.userInfo.tenantCode,
      //   adminFlag: ctx.userInfo.adminFlag,
      //   // selfCompanyDepartmentTreeFlag: true,
      // },
      disabled: true,
    },
    // {
    //   prop: 'saleDepartmentName',
    //   name: '销售组织',
    //   type: 'treeSelect',
    //   apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
    //   isName: true, // 是否返回名字
    //   multiple: false,
    //   returnType: 'object', // 全部返回当前对象
    //   currentValue: ctx.baseInfoData.saleDepartmentNo, // 默认选中的
    //   // currentValue: '7024', // 默认选中的
    //   apiData: {
    //     tenantCode: ctx.userInfo.tenantCode,
    //     adminFlag: ctx.userInfo.adminFlag,
    //     // selfCompanyDepartmentTreeFlag: true,
    //   },
    //   // fixme
    // },
    // {
    //   name: '签约抬头',
    //   prop: 'signTitle',
    //   type: 'ajaxSelect',
    //   apiUrl: BASE_API.DIC_CREDIT_API,
    //   apiData: { dictType: 'INTERMODALITY-SIGN-TITLE' },
    //   valueKey: 'label',
    //   labelKey: 'label',
    //   currentValue: ctx.baseInfoData.signTitle,
    // },
    {
      name: '合同总金额',
      prop: 'contractTotalAmount',
      type: 'inputNumber',
      max: 9999999999,
      precision: 6,
    },
    {
      prop: ctx.isCustomerContract ? 'customerCode' : 'supplierCode',
      type: 'searchTableSpec',
      name: ctx.isCustomerContract ? '客户名称' : '供方名称',
      searchType: ctx.isCustomerContract ? 'customer' : 'supplier',
      currentValue: ctx.isCustomerContract
        ? ctx.baseInfoData.customerName
        : ctx.baseInfoData.supplierName, // 默认选中的
      checkRowKeys: [
        ctx.isCustomerContract
          ? ctx.baseInfoData?.customerCode || null
          : ctx.baseInfoData?.supplierCode || null,
      ],
      changeMethod: 'changeMethod',
      extraData: {
        partnerTypes: ctx.isCustomerContract ? 'HZHB01' : 'HZHB02',
        companyCode: ctx.userInfo.companyCode,
      },
      isMultiple: true,
    },
    {
      name: '项目编号',
      prop: 'projectCode',
      type: 'input',
      placeholder: '请选择项目',
    },
    {
      name: '项目名称',
      prop: 'projectName',
      type: 'input',
      disabled: true,
      placeholder: '请选择项目',
    },
    {
      name: '平台公司',
      prop: 'platformCompanyName',
      type: 'select',
      options: ctx.curPlatformCompanyList,
      currentValue: ctx.baseInfoData.platformCompanyName,
      value: 'createCompanyName',
      label: 'createCompanyName',
      changeMethod: 'changeMethod',
    },
    {
      name: '业务部门',
      prop: 'businessDepartmentCode',
      type: 'select',
      options: ctx.curDepartmentList,
      currentValue: ctx.baseInfoData.businessDepartmentCode,
      changeMethod: 'changeMethod',
    },
    { name: '合同数量', prop: 'contractNumber', type: 'input', placeholder: '一式X份' },
    {
      name: '是否需要加盖法人章',
      prop: 'isCorporateSeal',
      type: 'select',

      options: [
        { value: '0', label: '是' },
        { value: '1', label: '否' },
      ],
    },
    {
      name: '对方联系人',
      prop: 'contactPerson',
      type: 'input',
    },
    {
      name: '联系电话',
      prop: 'contactPhone',
      type: 'inputNumber',
    },
    {
      name: '合同签订日期',
      prop: 'contractSignDate',
      type: 'date',
    },
    {
      name: '合同起始时间',
      prop: 'contractEffectDate',
      changeMethod: 'changeMethod',
      type: 'date',
    },
    {
      prop: 'hasExpirationDate',
      name: '是否规定失效日期',
      type: 'select',
      changeMethod: 'changeMethod',
      options: [
        { value: '0', label: '是' },
        { value: '1', label: '否' },
      ],
    },
    {
      name: '合同终止时间',
      prop: 'contractExpireDate',
      changeMethod: 'changeMethod',
      type: 'date',
    },
    //新加字段
    {
      name: '业务类型',
      prop: 'projectBusinessTypeNo',
      // type: 'select',
      // options: [
      //   { value: '0', label: '一类业务' },
      //   { value: '1', label: '二类业务' },
      //   { value: '2', label: '三类业务' },
      // ],
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'mto_business_type' },
      currentValue: ctx.baseInfoData.projectBusinessTypeNo,
      changeMethod: 'changeMethod',
    },
    {
      name: '是否为我方格式',
      prop: 'isOurFormat',
      type: 'select',
      options: [
        { value: '0', label: '是' },
        { value: '1', label: '否' },
      ],
    },
    {
      name: '新签或续签',
      prop: 'renewOrNewSignature',
      type: 'select',
      options: [
        { value: '0', label: '新签' },
        { value: '1', label: '续签' },
      ],
    },
    { name: '时长', prop: 'duration', type: 'input', disabled: true, placeholder: '自动计算' },
    {
      name: '合同类型',
      prop: 'contractType',
      type: 'select',
      options: [
        { value: '0', label: '常规合同' },
        { value: '1', label: '结算条款' },
      ],
      disabled: true,
    },
    {
      name: '经办人员',
      prop: 'chargePersonId',
      type: 'searchTableSpec',
      isMultiple: true,
      currentValue: ctx.baseInfoData.chargePersonName,
      searchType: 'personnel',
      changeMethod: 'changeMethod',
    },
    {
      name: '创建人',
      visible: ctx.pageMode != 0,
      disabled: true,
      prop: 'createByName',
      type: 'input',
    },
    {
      name: '合同性质',
      type: 'dict',
      dictType: 'MTO_CONTRACT_NATURE',
      prop: 'contractNature',
    },
    ...(!ctx.isCustomerContract
      ? [
          {
            name: '可使用部门',
            prop: 'usableDepartmentName',
            type: 'select',
            options: [],
            disabled: true,
          },
        ]
      : []),
    {
      name: '合同主要内容',
      prop: 'remarks',
      type: 'textarea',
      maxlength: 1000,
      span: 24,
    },
  ];
};
